import React from 'react';
import { Star, Users, TrendingUp } from 'lucide-react';
import { trustMetrics } from '../data/mock';

const TrustSection = () => {
  return (
    <section className="py-8 bg-gray-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-purple-900/50 via-gray-800 to-blue-900/50 rounded-3xl shadow-2xl shadow-purple-900/50 border border-purple-500/20">
          <div className="px-4 sm:px-6 lg:px-8 py-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {/* Title */}
              <div className="flex flex-col items-center justify-center space-y-2">
                <h3 className="text-white text-lg font-bold text-center">Trust & Growth</h3>
                <div className="flex space-x-2">
                  <div className="w-2.5 h-2.5 bg-purple-500 rounded-full animate-pulse"></div>
                  <div className="w-2.5 h-2.5 bg-blue-500 rounded-full animate-pulse animation-delay-200"></div>
                  <div className="w-2.5 h-2.5 bg-cyan-500 rounded-full animate-pulse animation-delay-400"></div>
                  <div className="w-2.5 h-2.5 bg-purple-400 rounded-full animate-pulse animation-delay-600"></div>
                </div>
              </div>

              {/* Trusted By */}
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl px-4 py-4 border border-purple-500/20 shadow-lg shadow-purple-900/30 flex items-center justify-center min-h-[100px]">
                <div className="flex flex-col items-center justify-center text-center space-y-2">
                  <Users className="h-6 w-6 text-purple-400" />
                  <div>
                    <p className="text-xs text-gray-400 font-medium">Trusted By</p>
                    <p className="text-sm font-bold text-white leading-tight">
                      Over {trustMetrics.businesses} Businesses
                    </p>
                  </div>
                </div>
              </div>

              {/* Rating */}
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl px-4 py-4 border border-purple-500/20 shadow-lg shadow-purple-900/30 flex items-center justify-center min-h-[100px]">
                <div className="flex flex-col items-center justify-center text-center space-y-2">
                  <div className="flex space-x-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-sm font-bold text-white leading-tight">
                    {trustMetrics.rating} ({trustMetrics.reviewCount}+ Reviews)
                  </p>
                </div>
              </div>

              {/* Monthly Traffic */}
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl px-4 py-4 border border-purple-500/20 shadow-lg shadow-purple-900/30 flex items-center justify-center min-h-[100px]">
                <div className="text-center w-full">
                  <p className="text-xs text-gray-400 font-medium mb-2">Monthly Traffic</p>
                  <p className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent mb-2">{trustMetrics.monthlyTraffic}</p>
                  <div className="w-full bg-gray-700 rounded-full h-1.5">
                    <div className="bg-gradient-to-r from-purple-500 to-blue-500 h-1.5 rounded-full" style={{ width: '75%' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;